module.exports = __webpack_public_path__ + "img/logo-no-bg.6b7a67ef.svg";